import { ClearbitIdentity } from '@clearkit/icons';
import classNames from 'classnames';
import { CKLayoutVertical } from 'clearkit';
import { FC } from 'react';

export type AuthLayoutProps = {
  children: React.ReactNode;
};

const AuthLayout: FC<AuthLayoutProps> = function({ children }) {
  return (
    <div className="flex flex-col items-center w-full h-full bg-gray-0">
      <div className="flex items-center h-full">
        <CKLayoutVertical alignItems="center" gap="3rem">
          <ClearbitIdentity className="w-6 h-6" />

          {children}
        </CKLayoutVertical>
      </div>
    </div>
  );
};

export default AuthLayout;

export type AuthLayoutHeaderProps = {
  header: React.ReactNode;
  description: React.ReactNode;
  className?: string;
};

export function AuthLayoutHeader({
  className,
  header,
  description,
}: AuthLayoutHeaderProps) {
  return (
    <div className={classNames(className, 'flex flex-col items-center')}>
      <h2 className="mb-6 text-3xl">{header}</h2>
      <p className="text-sm text-center w-72">{description} </p>
    </div>
  );
}

export function LayoutDivider({ text = 'or' }: { text?: string }) {
  return (
    <div className="flex items-center self-stretch gap-4">
      <div className="flex-grow h-px bg-gray-200"></div>
      <span className="text-xs font-medium text-gray-500 uppercase">
        {text}
      </span>
      <div className="flex-grow h-px bg-gray-200"></div>
    </div>
  );
}
